import React, {useCallback, useEffect, useState} from 'react'
import Table from "../Components/Table/Table";
import {Link} from "react-router-dom";
import {Api} from "../../../helpers/Api";
import Heading from "../Components/Heading/Heading";
import columnConfig from "../Main/Dashboard/columns";
import {connect} from "react-redux";
import DeleteModal from '../Components/Deletemodal/DeleteModal';
import Popup from "../Components/PopUp/Popup";
import { Col, Form } from 'react-bootstrap';
import ExportMetaData from '../Main/ExportMetaData/ExportMetaData';

const Reportconfig = {   
    url: "getAdminsReport",
    name: "Admin Report",
    columns: [
        { name: "Name", accessor:(object)=>{
            return object.Name;
        } },
        { name: "Download",accessor:(object)=>{
            if(object["eventWith"] == "IIC"){
               let links = `/iicreport/${object.id}`;
               return <Link to={links} >Download Report</Link>;
            }
            else if(object["eventWith"] == "RISE-Event"){
               let links = `/riseEventReport/${object.id}`;
               return <Link to={links} >Download Report</Link>;
            }
            else{
               let links = `/eventreport/${object.id}`;
               return <Link to={links} >Download Report</Link>;
            }
           
        }},
        { name: "Verified",accessor:(object)=>{
            if(object.Verified == true){
                return "verified";
            }
            else{
                return "Un-Verified";
            }
           
        }},
        { name: "Type",accessor:(object)=>{
            return object.eventWith;
        }},
        { name: "Action", key:"Action" }
    ]
}

const AdminReport = ({user, ...props}) => {
    const [ del, setDel ] = useState(false);
    const [ id, setId ] = useState();

    const params = {path: 'brands'}
    let config = Reportconfig;
    const [state, setState] = useState({
        loading: true,
        error: null,
        config: config,
        page: 1,
        limit: 10,
        total: 0,
        show: false,
    });
    const [school, setSchool] = useState(null);
    const [schoolValue, setSchoolValue] = useState(0);
    const [year, setYear] = useState(2024);
    const [department, setDepartment] = useState('All');
    const [listDepartment, setListDepartment] = useState(null);
    const [type,setType] = useState('All');
    const [posts, setPosts] = useState([]);
    const [total, setTotal] = useState();
    const tableref = new Table();


    const loadData = useCallback(() => {
        setState(s => {
            return {...s, loading: true}
        });
        let start = 0;
        const limit = state.limit;
        const page = state.page;
        start = (page - 1) * limit;
        Api.call(`/brands?_sort=name:ASC`).then(response =>{
            let schoolData = response.map(element => {
                return {value:element.id,name:element.name} 
            });
            setSchool(schoolData); 
        }).finally(()=>{
            Api.call(`/departments?_sort=name:ASC`).then(response=>{ 
                setListDepartment(response);

            }).finally(()=>{
                Api.call(`/getAdminsReportCount?limit=${limit}&skip=${start}&school=${schoolValue}&type=${type}&department=${department}`).then(response => {
                    setTotal(response[0].count)
                }).catch(console.log);
                Api.call(`/${config.url}?limit=${limit}&skip=${start}&school=${schoolValue}&type=${type}&department=${department}`).then(response => {
                    setPosts(response)
                }).catch(console.log).finally(()=>{
                    setState(s => {
                        return {...s, loading: false}
                    });
                })  
            }) 
        });     
    }, [config.url, state.page,schoolValue, state.limit]);

    const onPaginate = (page) => {
        setState({...state, page: page, loading: true})
    };

    useEffect(() => {
        console.log(school);
    }, [school]);

    useEffect(() => {
        if (!user) {
            return;
        }
        loadData()
    }, [ params.path,loadData, user]);

    useEffect(() => {
        setState(s => {
            return {...s, loading: true}
        });
        if (!user) {
            return;
        }
        let start = 0;
        const limit = state.limit;
        const page = state.page;
        start = (page - 1) * limit;
        Api.call(`/getAdminsReportCount?limit=${limit}&skip=${start}&school=${schoolValue}&type=${type}&department=${department}`).then(response => {
            setTotal(response[0].count)
        }).catch(console.log);
        Api.call(`/${config.url}?limit=${limit}&skip=${start}&school=${schoolValue}&type=${type}&department=${department}`).then(response => {
            setPosts(response)
        }).catch(console.log).finally(_ => {
            setState(s => {
                return {...s, loading: false}
            });
        });
    }, [schoolValue,type,department]);
    

    const parsePatient = (post) => {
        let row = state.config.columns.map((column) => {
            if (column.accessor) {
                return column.accessor(post);
            }
            return post[column.key];
        });
        console.log({row});
        return row;
    };

    const renderRow = (row, index) => {
        let columnIndex = 0;
        let patient = parsePatient(row);
        return <tr key={index}>
            <td key={index}>{`${(state.page - 1) * state.limit+(index+1)}`}</td>
            {patient.map(column => {
                return renderColumn(column, columnIndex++, index, patient, row);
            })}</tr>
    };

    const selectAll = () => {
        let allSelected = !state.allSelected;
        let row = state.row.map(patient => {
            patient.selected = allSelected;
            return patient;
        });
        setState({...state, row: row, allSelected: allSelected});
    };

    const onDelete = (event, index) => {
        event.preventDefault();
        if (!window.confirm('Are you sure you want to delete this item?')) {
            return;
        }
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}`, "DELETE").then(response => {
            loadData();
        })
    };

    const onUp = (event, index) => {
        event.preventDefault();
        setState({...state, loading: true})
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/up`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const onDown = (event, index) => {
        setState({...state, loading: true})
        event.preventDefault();

        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/down`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const renderColumn = (column, index, rowIndex, row, originalRow) => {
        if (index === row.length - 1) {

            if (state.config.renderActions) {
                return state.config.renderActions(column, index, rowIndex, row, originalRow, onUp , onDown,onDelete, state, config);
            }
            else {
                return <td key={index}>
                <ul>
                    <li>                          
                        <Link to={`/Report/${originalRow.id}/${params.id}`}>
                        {columnConfig.editIcon}
                        </Link>
                    </li>
                </ul>
            </td>
        }
        }
        if (typeof column === "boolean") {
            return <td key={index}><span style={{color: column ? "green" : "red"}}>{column ? "Yes" : "No"}</span></td>
        }
        return <td key={index}>{column}</td>
    };
    const renderHeaderColumn = (column, index) => {

        return (
            <th key={index}>
                {column.name}
            </th>
        );
    };
    const yearChange = (e) =>{
        setYear(e.target.value);
    }

    const exportData = () =>{
        tableref.export(ExportMetaData.Reportconfig,posts);
    }

    return (
        <div className="right_container">
             <Popup trigger={del} icon='../../../../images/delete-icon.svg' actionParams={id} action={onDelete} class="delete-popup" setSearch={setDel}>
               <DeleteModal/>
            </Popup>
            <div className="dashboard">
                <div className='inner-content'>
                    <Heading name={config.name} school={school} departmentList={listDepartment} departmentChange={setDepartment}
                    schoolChange={setSchoolValue} onRefresh={loadData} typeChange={setType}
                    refreshlink="#" url={params.path}/>
                
                    <div className='commen-table'>
                        <Table serial={true} renderColumn={renderColumn} loading={state.loading}
                               renderRow={renderRow} renderHeaderColumn={renderHeaderColumn}
                               columns={state.config.columns} cardFooter="cardFooter" total={total}
                               currentPage={state.page} perPage={state.limit}
                               rows={posts} selected="Invite Selected" onPaginate={onPaginate}
                               onChangePerPage={(limit) => {
                                   setState({...state, limit});
                               }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({type: 'LOGIN', data: user})
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminReport)
